import React, { useEffect, useState } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { Button, Modal, Collapse, Row, Col } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faPen, faTrash } from '@fortawesome/free-solid-svg-icons';

import { GET_FIELDS, UPDATE_FIELD, ADD_NEW_FIELD } from '../../../Queries/options';
import { useDispatch, useSelector } from 'react-redux';
import { setLoader } from '../../../Slices/loaderSlice';
import { setNewObj, setDataBucket } from '../../../Slices/dataBucket';
import { message } from 'antd';
import Swal from 'sweetalert2';
import { InputField, SelectInput } from '../../../blueplanitUtils/InputField';
import { renderOptionsformultiple } from '../../../utilsdata';
import { DATA_BUCKET_DEPARTMENT } from '../../../databucket';
import { ACTIVE_STATUS2 } from '../../../databucket';

const DocumentManager = () => {
  const { data, loading, refetch } = useQuery(GET_FIELDS); // Fetch fields
  const [updateField] = useMutation(UPDATE_FIELD); // Update field mutation
  const options = useSelector((state) => state.dataBucket.databucket);
  const [addField] = useMutation(ADD_NEW_FIELD, {
    onCompleted: (data) => {
      if (data.CreateDynamicField.status === false) {
        message.info({
          content: data.CreateDynamicField.message,
          duration: 5,
        });

      } else {
        message.success({
          content: data.CreateDynamicField.message,
          duration: 5,
        });

      }
    },
    onError: (error) => {
      message.error({
        content: "An error occurred. Please try again",
        duration: 5,
      });
    }
  });

  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState('create'); // 'create', 'edit', or 'createobj'
  const [currentField, setCurrentField] = useState(null);
  const [currentDocument, setCurrentDocument] = useState(null);
  const [formValues, setFormValues] = useState({ name: '', status: 'active' });

  const DataBucket = useSelector((state) => state.dataBucket.databucket);


  const openModal = (mode, field = null, document = null) => {
    setModalMode(mode);
    setCurrentField(field);
    setCurrentDocument(document);
    setFormValues(document || { name: '', status: '' });
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentField(null);
    setCurrentDocument(null);
    setFormValues({ name: '', status: 'active' });
  };

  const handleInputChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    try {
      if (!formValues.name || !formValues.status) {
        return;
      }
      closeModal(); // Close modal before saving
      if (modalMode === 'edit') {
        if (currentField && currentDocument) {
          const updatedData = {
            name: formValues.name,
            status: formValues.status,
          };
          await updateField({
            variables: {
              id: currentField?._id,
              obj: currentDocument?._id,
              newData: updatedData,
              key: false,
            },
          });

        }
      } else if (modalMode === 'createobj') {
        if (currentField) {
          const newFieldData = {
            name: formValues.name,
            status: formValues.status,
            flag: true,
          };
          await updateField({
            variables: {
              id: currentField?._id,
              newData: newFieldData,
            },
          });
          refetch()

        }
      } else if (modalMode === 'create') {

        if (formValues?.name) {
          const newCreatedData = await addField({
            variables: {
              name: formValues?.name?.toUpperCase().trim(),
              Department: formValues?.status,
            },
          });
          refetch()
          dispatch(setNewObj(newCreatedData.data.CreateDynamicField.response)); // Update Redux with new data
        }
      }
    } catch (error) {

    }
  };
  // Delete field or document
  const handleDelete = async (fieldId, docId) => {
    try {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'Do you really want to delete this field/document?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
      });
      if (result.isConfirmed) {
        if (!docId) {
          await updateField({
            variables: {
              id: fieldId,

              obj: null,

              newData: {},
              key: true,
            },
          });
          // dispatch(setNewObj({ id: fieldId, key: true }));
        } else {
          await updateField({
            variables: {
              id: fieldId,
              obj: docId,
              newData: {},
              key: true,
            },
          });
          // dispatch(setNewObj({ id: fieldId, objId: docId, key: true }));
        }

        Swal.fire('Deleted!', 'The document/field has been deleted.', 'success');

      }
      refetch();
    } catch (error) {
      console.error('Error deleting document/field:', error);
      Swal.fire('Error!', 'There was an error deleting the field/document.', 'error');
    }
  };
  const groupedByDepartment = {};

  DataBucket?.forEach((record) => {
    if (record?.status === true) {
      const department = record?.department || 'Others';
      if (!groupedByDepartment[department]) groupedByDepartment[department] = [];
      groupedByDepartment[department].push(record);
    }
  });


  useEffect(() => {
    dispatch(setLoader(loading));
  }, [loading, dispatch]);
  const formatFieldName = (fieldName) => {
    return fieldName
      .toLowerCase() // Convert the string to lowercase
      .replace(/_/g, " ") // Replace underscores with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
  };

  useEffect(() => {
    dispatch(setDataBucket(data?.GetDynamicField)); // Update Redux with initial data from query
  }, [refetch()]);
  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <div
          id="document_manager"
          style={{ display: 'flex', flexDirection: 'column', flex: '1 1 auto' }}
        >
          <div
            className="card-body"
            style={{
              margin: '0 auto',
              padding: '20px',
              background: '#fff',
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              maxWidth: '100%',
              width: '90%',
            }}
          >
            <h2 style={{ textAlign: 'center', fontSize: '1.5rem' }}>Data Bucket</h2>

            <Button
              type="primary"
              icon={<FontAwesomeIcon icon={faPlus} />}
              style={{ marginBottom: '16px', display: 'block', marginLeft: 'auto' }}
              onClick={() => openModal('create')}
            >
              Add New Field
            </Button>

            {Object.entries(groupedByDepartment).map(([department, fields]) => (
              <div key={department} style={{ marginBottom: 20 }}>
                <h3 style={{
                  fontWeight: 600,
                  fontSize: '18px',
                  fontFamily: 'Segoe UI, Roboto, Helvetica, Arial, sans-serif',
                  color: '#2c3e50',
                  marginBottom: '8px'
                }}>
                  {department}
                </h3>

                <Collapse
                  accordion
                  items={fields
                    .filter((field) => field?.status)
                    .map((field, index) => ({
                      key: `${index}-${department}`,
                      label: (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          {formatFieldName(field?.name || 'Unnamed')}
                          <FontAwesomeIcon icon={faTrash}
                            style={{ color: '#ff4d4f', cursor: 'pointer' }}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent collapsing
                              handleDelete(field._id);
                            }}
                          />
                        </div>
                      ),
                      children: (
                        <>
                          <Row gutter={[10, 10]} style={{ marginBottom: '16px' }}>
                            {(field?.data || [])
                              .filter((record) => record.flag)
                              .map((record) => (
                                <Col span={8} key={record._id}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      padding: '8px',
                                      border: '1px solid #f0f0f0',
                                      borderRadius: '4px',
                                    }}
                                  >
                                    <div>
                                      <div>
                                        <strong>Name:</strong> {record?.name}
                                      </div>
                                      <div>
                                        <strong>Status:</strong> {record?.status}
                                      </div>
                                    </div>
                                    <div style={{ display: 'flex', gap: '8px' }}>
                                      <FontAwesomeIcon icon={faPen}
                                        style={{ color: '#1890ff', cursor: 'pointer' }}
                                        onClick={() => openModal('edit', field, record)}
                                      />
                                      <FontAwesomeIcon icon={faTrash}
                                        style={{ color: '#ff4d4f', cursor: 'pointer' }}
                                        onClick={() => {
                                          handleDelete(field._id, record._id);
                                        }}
                                      />
                                    </div>
                                  </div>
                                </Col>
                              ))}
                          </Row>
                          <Button
                            type="dashed"
                            icon={<FontAwesomeIcon icon={faPlus} />}
                            onClick={() => openModal('createobj', field)}
                            style={{ marginTop: '16px' }}
                          >
                            Add New Document
                          </Button>
                        </>
                      ),
                    }))}
                ></Collapse>

              </div>
            ))}

            <Modal
              title={modalMode === 'edit' ? 'Edit Document' : 'Add New Field'}
              open={isModalOpen}
              onCancel={closeModal}
              onOk={handleSave}
              styles={{ body: { padding: '24px' } }}
            // bodyStyle={{ padding: '24px' }}
            >
              <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                  <InputField
                    name="name"
                    placeholder="Name"
                    value={
                      modalMode !== 'create'
                        ? formValues.name
                        : formValues.name?.toUpperCase().trim()
                    }
                    onChange={handleInputChange}
                  />
                </Col>

                <Col xs={24} md={12}>
                  {modalMode !== 'create' ? <SelectInput
                    required={true}
                    formControl={true}
                    name="status"
                    placeholder="Select Status"
                    value={formValues?.status}
                    onChange={(e) =>
                      handleInputChange({
                        target: {
                          name: 'status',
                          value: e,
                        },
                      })
                    }
                    style={{
                      height: '100%',
                      minHeight: '40px',
                      lineHeight: '40px',
                      border: 'none',
                    }}
                    options={renderOptionsformultiple(options, { name: 'ACTIVE_STATUS2' }, ACTIVE_STATUS2)}
                  /> : <SelectInput
                    required={true}
                    formControl={true}
                    name="status"
                    placeholder="Select Status"
                    value={formValues?.status}
                    onChange={(e) =>
                      handleInputChange({
                        target: {
                          name: 'status',
                          value: e,
                        },
                      })
                    }
                    style={{
                      height: '100%',
                      minHeight: '40px',
                      lineHeight: '40px',
                      border: 'none',
                    }}
                    options={renderOptionsformultiple(options, { name: 'DATA_BUCKET_DEPARTMENT' }, DATA_BUCKET_DEPARTMENT)}
                  />}
                </Col>
              </Row>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );

};

export default DocumentManager;